import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import 'react-big-calendar/lib/css/react-big-calendar.css'
import './styles/print.css';

import AuthWrapper from './components/AuthWrapper';
import { useAuth } from './lib/useAuth';

import LoginPage from './pages/login/page';
import AuthFbPage from './pages/login/auth-fb/page';
import AuthMagicLinkPage from './pages/auth-magic-link/page';
import LogoutPage from './pages/logout/page';
import SetupPage from './pages/setup/page';
import EsqueciSenhaRedirect from './pages/esqueci-senha/redirect';
import RedefinirSenhaPage from './pages/redefinir-senha/page';
import ChatPage from './pages/chat/page';
import CanalPage from './pages/canal/page';
import OnboardPage from './pages/onboard';
import InscricaoConfigPage from './pages/inscricao/InscricaoConfig';
import DialogoPage from './pages/dialogo/page';
import DialogoManualPage from './pages/dialogo/manual';
import WebchatPage from './pages/webchat/page';
import AtalhoMensagemPage from './pages/atalho_mensagem/page';
import IntegracaoApiPage from './pages/integracao_api/page';
import FilaAtendimentoPage from './pages/fila_atendimento/page';
import RelatoriosPage from './pages/relatorios/page';
import RelatoriosVendasPage from './pages/relatorios/vendas';
import RelatoriosSalvosPage from './pages/relatorios/salvos';
import RelatorioFinanceiroPage from './pages/relatorios/financeiro/page';
import FluxoCaixaPage from './pages/relatorios/fluxo_caixa/page';
import RelatorioAtendimentoHumanoPage from './pages/relatorios/atendimento_humano/page';
import UsuariosPage from './pages/usuario/page';
import UsuarioGruposPage from './pages/usuario_grupo/page';
import HistoricoMensgensPage from './pages/historico_mensagens/page';
import EmpresaPage from './pages/empresa/page';
import PerfilPage from './pages/perfil/page';
import CalendarioPage from './pages/calendario/page';
import TicketPage from './pages/ticket/page';
import MensagemProgramadaPage from './pages/mensagem_programada/page';
import CampanhaMensagemPage from './pages/campanha_mensagem/page';
import MensagensCampanhaPage from './pages/campanha_mensagem/mensagens';
import CampanhaMovidaPage from './pages/campanha_mensagem/PageMovida';
import ClientePage from './pages/cliente/page';
import CrmDashboardPage from './pages/crm_dashboard/page';
import MarcadorPage from './pages/marcador/page';
import AuditoriaPage from './pages/auditoria/page';
import IaClassificacaoPage from './pages/ia_classificacao/page';
import FaturaPage from './pages/fatura/page';
import FaturaViewPage from './pages/fatura/view_fatura';
import BaseConhecimentoPage from './pages/base_conhecimento/page';
import BaseConhecimentoViewPage from './pages/base_conhecimento/view';
import IAAgentePage from './pages/ia_agente/page';
import McpServidorPage from './pages/mcp_servidor/page';
import IASupervisionPage from './pages/ia_supervisao/page';
import ClienteGrupoPage from './pages/cliente_grupo/page';
import ProdutoPage from './pages/produto/page';
import LancamentoFinanceiroPage from './pages/lancamento_financeiro/page';
import CategoriaFinanceiraPage from './pages/categoria_financeira/page';
import CentroCustoPage from './pages/centro_custo/page';
import LancamentoFinanceiroRecorrenciaPage from './pages/lancamento_financeiro_recorrencia/page';
import VendaPage from './pages/venda/page';
import AtividadesPage from './pages/crm_atividades/page';
import AtividadesGoglPage from './pages/crm_atividades/gogl';
import AtividadesZohoPage from './pages/crm_atividades/zoho';
import AgendasPage from './pages/agenda/page';
import WhatsappCallbackPage from './pages/canal/whatsappCallback';
import CanalAuthCallbackPage from './pages/canal/callback';
import EstruturaDadosPage from './pages/estrutura_dados/page';
import DatasetPage from './pages/dataset/page';
import CatalogoPage from './pages/catalogo/page';
import OrcamentoPublicoPage from './pages/orcamento/page';
import OrcamentosPage from './pages/orcamentos/page';
import FormularioPublicoPage from './pages/formulario/page';
import IntegrationsPage from './pages/integrations/page';
import LigacaoPage from './pages/ligacao/page';
import FilaLigacaoPage from './pages/fila_ligacao/page';
import ConfiguracoesPage from './pages/configuracoes/page';
import GerenciamentoDadosPage from './pages/gerenciamento_dados/page';
import ChatInternoPage from './pages/chat_interno/page';
import TermosUsoPage from './pages/termos-uso/page';
import PoliticaPrivacidadePage from './pages/politica-privacidade/page';
import PoliticaDpoPage from './pages/politica-dpo/page';
import PoliticaRetencaoPage from './pages/politica-retencao/page';
import UpgradePlanoPage from './pages/upgrade-plano/page';
import PlanoPage from './pages/plano/page';
import NotFoundPage from './pages/not-found/page';

import { QueryClient, QueryClientProvider } from 'react-query';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './theme-default.css';
import './index.css';
// Inicializa o socket globalmente para sobreviver entre trocas de rota
import './components/navegacao/socket';

import { Navigate } from 'react-router-dom';

import * as Sentry from "@sentry/react";
import { queryClient } from './queryClient';
import { logError } from "./utils/logger";
import { startRecording } from "./lib/sessionRecorder";

startRecording();

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://1e7a8ad41f3ec5e2c52a64c3b1d1c707@o4506462548197376.ingest.us.sentry.io/4508541287137280",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/.+?.terachat\.com\.br\/api/, /^https:\/\/.+?.terachat\.app\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

window.addEventListener("error", (event) => {
  logError(event.error || new Error("Erro desconhecido"));
});

window.addEventListener("unhandledrejection", (event) => {
  logError(event.reason || new Error("Rejeição não tratada"));
});

/**
 * Páginas do editor de fluxo, carregadas sob demanda.
 *
 * Todas puxam `flow-castro` (direto ou pelos portRenderers). Como as demais
 * rotas são importadas de forma ansiosa, mantê-las aqui faria a página PÚBLICA
 * do formulário — aberta pelo cliente final, fora de qualquer autenticação —
 * baixar e avaliar o editor inteiro só para desenhar um formulário.
 */
const DialogoEditPage = React.lazy(() => import('./pages/dialogo/edit'));
const DialogoDebugPage = React.lazy(() => import('./pages/dialogo/debug'));
const MiniFormularioPage = React.lazy(() => import('./pages/mini_formulario/page'));
const FunilVendaPage = React.lazy(() => import('./pages/funil_venda/page'));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const IndexRedirect: React.FC = () => {
  const { user } = useAuth();
  if (user?.papel === 'VENDEDOR') {
    return <Navigate to="/crm_dashboard" replace />;
  }
  return <Navigate to="/chat" replace />;
};

if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child: any) {
    if (child.parentNode !== this) {
      if (console) {
        console.error('Cannot remove a child from a different parent', child, this);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments as any);
  }

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode: any, referenceNode: any) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments as any);
  }
}

root.render(
  <>
    <QueryClientProvider client={queryClient}>
      <Router>
        {/* Sem fallback visível: as rotas preguiçosas ficam atrás do
            AuthWrapper e já têm skeleton próprio; um texto aqui só piscaria. */}
        <React.Suspense fallback={null}>
        <Routes>
          <Route
            path="/"
            element={
              <AuthWrapper>
                <IndexRedirect />
              </AuthWrapper>
            }
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/auth-fb" element={<AuthFbPage />} />
          <Route path="/auth/magic-link" element={<AuthMagicLinkPage />} />
          <Route path="/esqueci-senha" element={<EsqueciSenhaRedirect />} />
          <Route path="/redefinir-senha" element={<RedefinirSenhaPage />} />
          <Route
            path="/logout"
            element={
              <AuthWrapper>
                <LogoutPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/chat"
            element={
              <AuthWrapper>
                <ChatPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/canal"
            element={
              <AuthWrapper>
                <CanalPage />
              </AuthWrapper>
            }
          />
          <Route path="/onboard" element={<OnboardPage />} />
          <Route path="/setup" element={<SetupPage />} />
          <Route path="/inscricao/org/:uuid/config" element={<InscricaoConfigPage />} />
          <Route
            path="/dialogo"
            element={
              <AuthWrapper>
                <DialogoPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/dialogo/manual"
            element={
              <AuthWrapper>
                <DialogoManualPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/dialogo/:id/debug"
            element={
              <AuthWrapper>
                <DialogoDebugPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/dialogo/:id"
            element={
              <AuthWrapper>
                <DialogoEditPage />
              </AuthWrapper>
            }
          />
          <Route path="/webchat" element={<WebchatPage />} />
          <Route path="/formulario/:token" element={<FormularioPublicoPage />} />
          <Route path="/orcamento/:token" element={<OrcamentoPublicoPage />} />
          <Route
            path="/atalho_mensagem"
            element={
              <AuthWrapper>
                <AtalhoMensagemPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/integracao_api"
            element={
              <AuthWrapper>
                <IntegracaoApiPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/fila_atendimento"
            element={
              <AuthWrapper>
                <FilaAtendimentoPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/relatorios"
            element={
              <AuthWrapper>
                <RelatoriosPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/relatorios/vendas"
            element={
              <AuthWrapper>
                <RelatoriosVendasPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/relatorios/salvos"
            element={
              <AuthWrapper>
                <RelatoriosSalvosPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/relatorios/financeiro"
            element={
              <AuthWrapper>
                <RelatorioFinanceiroPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/relatorios/fluxo_caixa"
            element={
              <AuthWrapper>
                <FluxoCaixaPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/relatorios/atendimento_humano"
            element={
              <AuthWrapper>
                <RelatorioAtendimentoHumanoPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/usuario"
            element={
              <AuthWrapper>
                <UsuariosPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/usuario_grupo"
            element={
              <AuthWrapper>
                <UsuarioGruposPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/historico_mensagens"
            element={
              <AuthWrapper>
                <HistoricoMensgensPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/perfil"
            element={
              <AuthWrapper>
                <PerfilPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/configuracoes"
            element={
              <AuthWrapper>
                <ConfiguracoesPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/calendario"
            element={
              <AuthWrapper>
                <CalendarioPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/mensagem_programada"
            element={
              <AuthWrapper>
                <MensagemProgramadaPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/campanha_movida"
            element={
              <AuthWrapper>
                <CampanhaMovidaPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/campanha_mensagem"
            element={
              <AuthWrapper>
                <CampanhaMensagemPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/campanha_mensagem/:id/mensagens"
            element={
              <AuthWrapper>
                <MensagensCampanhaPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/cliente"
            element={
              <AuthWrapper>
                <ClientePage />
              </AuthWrapper>
            }
          />
          <Route
            path="/crm_dashboard"
            element={
              <AuthWrapper>
                <CrmDashboardPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/marcador"
            element={
              <AuthWrapper>
                <MarcadorPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/auditoria"
            element={
              <AuthWrapper>
                <AuditoriaPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/ia_classificacao"
            element={
              <AuthWrapper>
                <IaClassificacaoPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/empresa"
            element={
              <AuthWrapper>
                <EmpresaPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/fatura"
            element={
              <AuthWrapper>
                <FaturaPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/fatura/:id"
            element={
              <AuthWrapper>
                <FaturaViewPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/base_conhecimento"
            element={
              <AuthWrapper>
                <BaseConhecimentoPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/base_conhecimento/:id/view"
            element={
              <AuthWrapper>
                <BaseConhecimentoViewPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/ia_agente"
            element={
              <AuthWrapper>
                <IAAgentePage />
              </AuthWrapper>
            }
          />

          <Route
            path="/mcp_servidor"
            element={
              <AuthWrapper>
                <McpServidorPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/ia/supervisao"
            element={
              <AuthWrapper>
                <IASupervisionPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/cliente_grupo"
            element={
              <AuthWrapper>
                <ClienteGrupoPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/produto"
            element={
              <AuthWrapper>
                <ProdutoPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/lancamento_financeiro"
            element={
              <AuthWrapper>
                <LancamentoFinanceiroPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/categoria_financeira"
            element={
              <AuthWrapper>
                <CategoriaFinanceiraPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/centro_custo"
            element={
              <AuthWrapper>
                <CentroCustoPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/lancamento_financeiro_recorrencia"
            element={
              <AuthWrapper>
                <LancamentoFinanceiroRecorrenciaPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/venda"
            element={
              <AuthWrapper>
                <VendaPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/funil_venda"
            element={
              <AuthWrapper>
                <FunilVendaPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/atividade"
            element={
              <AuthWrapper>
                <AtividadesPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/atividade/gogl/auth/callback"
            element={
              <AtividadesGoglPage />
            }
          />
          <Route
            path="/atividade/zoho/auth/callback"
            element={
              <AtividadesZohoPage />
            }
          />
          <Route
            path="/canal/whatsapp/auth/callback"
            element={
              <WhatsappCallbackPage />
            }
          />


          <Route
            path="/canal/instagram/auth/callback"
            element={
              <CanalAuthCallbackPage />
            }
          />

          <Route
            path="/agenda"
            element={
              <AuthWrapper>
                <AgendasPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/ticket"
            element={
              <AuthWrapper>
                <TicketPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/estrutura_dados"
            element={
              <AuthWrapper>
                <EstruturaDadosPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/dataset"
            element={
              <AuthWrapper>
                <DatasetPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/catalogo"
            element={
              <AuthWrapper>
                <CatalogoPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/orcamentos"
            element={
              <AuthWrapper>
                <OrcamentosPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/mini_formulario"
            element={
              <AuthWrapper>
                <MiniFormularioPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/gerenciamento_dados"
            element={
              <AuthWrapper>
                <GerenciamentoDadosPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/integrations"
            element={
              <AuthWrapper>
                <IntegrationsPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/ligacao"
            element={
              <AuthWrapper>
                <LigacaoPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/fila_ligacao"
            element={
              <AuthWrapper>
                <FilaLigacaoPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/chat_interno"
            element={
              <AuthWrapper>
                <ChatInternoPage />
              </AuthWrapper>
            }
          />

          <Route path="/termos-uso" element={<TermosUsoPage />} />
          <Route path="/politica-privacidade" element={<PoliticaPrivacidadePage />} />
          <Route path="/politica/dpo" element={<PoliticaDpoPage />} />
          <Route path="/politica/retencao" element={<PoliticaRetencaoPage />} />

          <Route
            path="/upgrade-plano"
            element={
              <AuthWrapper>
                <UpgradePlanoPage />
              </AuthWrapper>
            }
          />

          <Route
            path="/plano"
            element={
              <AuthWrapper>
                <PlanoPage />
              </AuthWrapper>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </React.Suspense>
      </Router>
    </QueryClientProvider>
    <ToastContainer />
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
